// loading states
export const LOADING_COMPANYLIST = 'LOADING_COMPANYLIST'
export const LOADING_AGREEMENTLIST = 'LOADING_AGREEMENTLIST'
export const COMPANY_SYNC_LOADING = 'COMPANY_SYNC_LOADING'
export const LOADING_COMPANY_HISTORY = 'LOADING_COMPANY_HISTORY'
export const LOADING_COMPANY_AUDIT = 'LOADING_COMPANY_AUDIT'
export const LOADING_COMPANY_SETTINGS = 'LOADING_COMPANY_SETTINGS'

// loaded states
export const AGREEMENT_LIST_LOADED = 'AGREEMENT_LIST_LOADED'
export const COMPANY_DETAILS_LOADED = 'COMPANY_DETAILS_LOADED'
export const SETUP_COMPANY_LIST_LOADED = 'SETUP_COMPANY_LIST_LOADED'
export const COMPANY_SYNC_HISTORY_LOADED = 'COMPANY_SYNC_HISTORY_LOADED'
export const COMPANY_AUDIT_LOADED = 'COMPANY_AUDIT_LOADED'
export const COMPANY_LIST_LOADED = 'COMPANY_LIST_LOADED'
export const COMPANY_VALIDATED = 'COMPANY_VALIDATED'
export const UNSYNCED_LIST_LOADED = 'UNSYNCED_LIST_LOADED'
export const COMPANY_HISTORY_LOADED = 'COMPANY_HISTORY_LOADED'
export const COMPANY_SETTINGS_LOADED = 'COMPANY_SETTINGS_LOADED'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_EXCLUDE_SUCCESS = 'USER_EXCLUDE_SUCCESS'

// updated states
export const COMPANY_DETAILS_USERS_UPDATED = 'COMPANY_DETAILS_USERS_UPDATED'
export const SELECTED_COMPANY_UPDATED = 'SELECTED_COMPANY_UPDATED'
export const COMPANY_SELECTED = 'COMPANY_SELECTED'
export const USER_SELECTED = 'USER_SELECTED'
export const AGREEMENT_SELECTED = 'AGREEMENT_SELECTED'

// navigation states
export const SHOW_LOGIN_PAGE = 'SHOW_LOGIN_PAGE'
export const BACK_TO_COMPANIES = 'BACK_TO_COMPANIES'

export const DISMISS_TOAST = 'DISMISS_TOAST'
export const ADD_TOAST = 'ADD_TOAST'
